export default {
  initializeBIC: 'initializeBIC',
  initializeBICSearch: 'initializeBICSearch',
  initializeCategory: 'initializeCategory',
  initializeMerchants: 'initializeMerchants',
  toggleFilter: 'toggleFilter',
  changeFilterStatus: 'changeFilterStatus',
  initializeTransactionHistory: 'initializeTransactionHistory',
  initializeFaqScreen: 'initializeFaqScreen',
  initializeChangePin: 'initializeChangePin',
  initializeHTB: 'initializeHTB',
  initializeVoucher: 'initializeVoucher',
  initializeLogin: 'initializeLogin',
  initializeAccountLogin: 'initializeAccountLogin',
  checkUserEligible: 'checkUserEligible',
  updateSearchText: 'updateSearchText',
  clickCategorySeeMore: 'clickCategorySeeMore',
  clickCategory: 'clickCategory',
  clickMerchantSeeMore: 'clickMerchantSeeMore',
  clickMerchant: 'clickMerchant',
  clickBrandsSeeMore: 'clickBrandsSeeMore',
  clickBrands: 'clickBrands',
  toggleSearchAndFilterCategoryPage: 'toggleSearchAndFilterCategoryPage',
};



// WEBPACK FOOTER //
// ./actions/bicAction/actionType.js